import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useParameterBoreholeWaterbearingCreateMutation, useParameterBoreholeWaterbearingDeleteMutation, useParameterBoreholeWaterbearingFindAllQuery, useParameterBoreholeWaterbearingUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import groundwaterSvg from "../../../assets/images/svg/groundwater.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";

const WaterBearing = ({ boreholeId }: any) => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useParameterBoreholeWaterbearingFindAllQuery(`?borehole_id=${id}`);
  const [waterBearingCreate, waterBearingCreateResult] = useParameterBoreholeWaterbearingCreateMutation();
  const [waterBearingUpdate, waterBearingUpdateResult] = useParameterBoreholeWaterbearingUpdateMutation();
  const [waterBearingDelete, waterBearingDeleteResult] = useParameterBoreholeWaterbearingDeleteMutation();

  const [waterbearing, setWaterbearing] = useState<any>();

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  useEffect(() => {
    if (waterbearing === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    if (data?.data.length !== 0) {
      setMeasurementList(data?.data);
      setMeaCount(measurementList?.length);
    } else if (is_newCreated) {
      setLoading(false);
    } else {
      setMeasurementList(null)
      setMeaCount(null)
      setLoading(true);
      setWaterbearing(null)
    }

  }, [waterbearing, id, data?.data, boreholeId, is_newCreated])


  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: waterbearing?.id,
      borehole_id: waterbearing?.borehole_id,
      borehole_code: waterbearing?.borehole_code,
      measure_date: waterbearing?.measure_date,
      waterbearing_rocks_lithological: waterbearing?.waterbearing_rocks_lithological,
      rocks_index_geologicalage: waterbearing?.rocks_index_geologicalage,
      waterbearing_depth_location: waterbearing?.waterbearing_depth_location,
      waterbearing_thickness: waterbearing?.waterbearing_thickness,
      pumping_test_type: waterbearing?.pumping_test_type,
    },
    validationSchema: Yup.object({
      borehole_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      rocks_index_geologicalage: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_depth_location: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"), waterbearing_thickness: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pumping_test_type: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      waterbearing_rocks_lithological: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (waterbearing !== null) {
        const updateList = {
          id: waterbearing?.id,
          borehole_id: waterbearing?.borehole_id,
          borehole_code: values.borehole_code,
          measure_date: values.measure_date,
          waterbearing_rocks_lithological: values.waterbearing_rocks_lithological,
          rocks_index_geologicalage: values.rocks_index_geologicalage,
          waterbearing_depth_location: values.waterbearing_depth_location,
          waterbearing_thickness: values.waterbearing_thickness,
          pumping_test_type: values.pumping_test_type,
        }
        waterBearingUpdate(updateList);
      } else {
        const newList = {
          borehole_id: id,
          borehole_code: values["borehole_code"],
          measure_date: values["measure_date"],
          waterbearing_rocks_lithological: values["waterbearing_rocks_lithological"],
          rocks_index_geologicalage: values["rocks_index_geologicalage"],
          waterbearing_depth_location: values["waterbearing_depth_location"],
          waterbearing_thickness: values["waterbearing_thickness "],
          pumping_test_type: values["pumping_test_type"],
        };
        waterBearingCreate(newList)
      }
      // validation.resetForm();
    },
  });


  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (waterbearing) {
      waterBearingDelete(waterbearing.id);
      setDeleteModal(false);
    }
    setWaterbearing(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={groundwaterSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setWaterbearing(null);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && waterbearing !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={waterbearing?.rocks_index_geologicalage}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setWaterbearing(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Уст үе давхрагын дугаар </Label>
                      <Input
                        name="borehole_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.borehole_code || ""}
                        invalid={
                          validation.touched.borehole_code &&
                            validation.errors.borehole_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.borehole_code &&
                        validation.errors.borehole_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.borehole_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ус агуулагч чулуулгийн литологийн бүрэлдэхүүн </Label>
                      <Input
                        name="waterbearing_rocks_lithological"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_rocks_lithological || ""}
                        invalid={
                          validation.touched.waterbearing_rocks_lithological &&
                            validation.errors.waterbearing_rocks_lithological
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_rocks_lithological &&
                        validation.errors.waterbearing_rocks_lithological ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_rocks_lithological}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Шавхалтын төрөл туршилт </Label>
                      <Input
                        name="pumping_test_type"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pumping_test_type || ""}
                        invalid={
                          validation.touched.pumping_test_type &&
                            validation.errors.pumping_test_type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pumping_test_type &&
                        validation.errors.pumping_test_type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pumping_test_type}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Уст давхрагын зузаан (м) </Label>
                      <Input
                        name="waterbearing_thickness"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_thickness || ""}
                        invalid={
                          validation.touched.waterbearing_thickness &&
                            validation.errors.waterbearing_thickness
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_thickness &&
                        validation.errors.waterbearing_thickness ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_thickness}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Уст давхрагын гүний байршил(м)  </Label>
                      <Input
                        name="waterbearing_depth_location"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.waterbearing_depth_location || ""}
                        invalid={
                          validation.touched.waterbearing_depth_location &&
                            validation.errors.waterbearing_depth_location
                            ? true
                            : false
                        }
                      />
                      {validation.touched.waterbearing_depth_location &&
                        validation.errors.waterbearing_depth_location ? (
                        <FormFeedback type="invalid">
                          {validation.errors.waterbearing_depth_location}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Чулуулгийн геологийн насны индекс </Label>
                      <Input
                        name="rocks_index_geologicalage"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.rocks_index_geologicalage || ""}
                        invalid={
                          validation.touched.rocks_index_geologicalage &&
                            validation.errors.rocks_index_geologicalage
                            ? true
                            : false
                        }
                      />
                      {validation.touched.rocks_index_geologicalage &&
                        validation.errors.rocks_index_geologicalage ? (
                        <FormFeedback type="invalid">
                          {validation.errors.rocks_index_geologicalage}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default WaterBearing;